import { render, staticRenderFns } from "./ModalZoom.vue?vue&type=template&id=318e4bf6&"
import script from "./ModalZoom.vue?vue&type=script&lang=js&"
export * from "./ModalZoom.vue?vue&type=script&lang=js&"
import style0 from "./ModalZoom.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports